import {
  ORGANIZATION_TYPE_SUCCESS,
  ORGANIZATION_TYPE_FAILED,
  RESET_ORGANIZATION_TYPE,
  LOADING_ORGANIZATION_TYPE,
  NETWORK_ERROR_ORGANIZATION_TYPE,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ORGANIZATION_TYPE:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
      };
    case ORGANIZATION_TYPE_FAILED:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: action.payload,
      };
    case ORGANIZATION_TYPE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
      };
    case NETWORK_ERROR_ORGANIZATION_TYPE:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
      };
    case RESET_ORGANIZATION_TYPE:
      return (state = initialState);
    default:
      return state;
  }
};
